import { useReducer } from "react";
import React, { useRef, useState, useCallback, useMemo } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Select from "react-select";
import GLOBALS from "../../utils/Globals";
import { destOptions } from "../../data/data";
import Iframe from "react-iframe";
import axios from "axios";
import { RotatingLines, Bars } from "react-loader-spinner";
import Footer from "../Footer/Footer";
import Button from "react-bootstrap/Button";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Popup from "reactjs-popup";
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "animate.css/animate.min.css";
import Form from "react-bootstrap/Form";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "../AgGrid/styles.css"
import MappingComponent from "../../components/Mapping/MappingComponent.tsx"

import {
  LicenseManager,
  RowApiModule,
  HighlightChangesModule,
  ValidationModule,
} from "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid
import "ag-grid-community/styles/ag-theme-material.css";
import ButtonRenderer from "../AgGrid/ButtonRenderer";
import statusRenderer from "../AgGrid/statusRenderer";

// const bounce = cssTransition({
//   enter: "animate__animated animate__bounceIn",
//   exit: "animate__animated animate__bounceOut",
// });

const baseURLSchemas =
  process.env.REACT_APP_ENV === "PROD"
    ? GLOBALS.PROD.baseURLSchemas
    : GLOBALS.DEV.baseURLSchemas;

const baseURLSaveUUID =
  process.env.REACT_APP_ENV === "PROD"
    ? GLOBALS.PROD.baseURLSaveUUID
    : GLOBALS.DEV.baseURLSaveUUID;

const baseURLSaveJob =
  process.env.REACT_APP_ENV === "PROD"
    ? GLOBALS.PROD.baseURLSaveJob
    : GLOBALS.DEV.baseURLSaveJob;

const baseURLGetJobs =
  process.env.REACT_APP_ENV === "PROD"
    ? GLOBALS.PROD.baseURLGetJobs
    : GLOBALS.DEV.baseURLGetJobs;

const baseURLGetSchema =
  process.env.REACT_APP_ENV === "PROD"
    ? GLOBALS.PROD.baseURLGetSchema
    : GLOBALS.DEV.baseURLGetSchema;

const baseURLGetDoc =
  process.env.REACT_APP_ENV === "PROD"
    ? GLOBALS.PROD.baseURLGetDoc
    : GLOBALS.DEV.baseURLGetDoc;

const baseURLGetDest =
  process.env.REACT_APP_ENV === "PROD"
    ? GLOBALS.PROD.baseURLGetDest
    : GLOBALS.DEV.baseURLGetDest;

const options = [];
const names = [];
const colourOptions = [];

function ImportDocument() {

  const gridRef = useRef();
  const [rowData, setRowData] = useState();
  //const [show, setShow] = useState(false);
  const navigate = useNavigate();

  const toastError = () =>
    toast.error("Please select a destination");

  const toastSuccess = () => toast.success("Data and Destination Verified!");

  const toastCancelImport = () => toast.warning("Cancelling Import");

  const toastPublished = () => toast.success("Publishing Successful!");

  var username = "";
  var url = "http://localhost:8080/example/test.html?dest=";

  const [job, setJob] = React.useState(null);
  const [url_mod, setUrl_Mod] = React.useState(null);
  const { isOpen, onOpen, onClose } = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  var isDisabled = true;

  const [loading, setLoading] = useState(false);
  const [userChoice, setUserChoice] = useState("");
  const [schemas, setSchemas] = useState(null);
  const [totJobs, setTotJobs] = useState(null);
  const [modalShow, setModalShow] = React.useState(false);

  const baseURLGetGS1 =
    process.env.REACT_APP_ENV == "PROD"
      ? GLOBALS.PROD.baseURLGetGS1
      : GLOBALS.DEV.baseURLGetGS1;

  const handleNavigate = () => {
    setModalShow(false);
    navigate("/");
  };

  async function getData(manuuid, owner, manufile, colourOptions) {
    const res = await axios.post(
      baseURLSaveUUID + "/" + manuuid + "/" + owner + "/" + manufile,
      {
        dest: colourOptions,
      }
    );
    return await res.json();
  }

  React.useEffect(() => {
    setTotJobs(0);
    var manufile = localStorage.getItem("manufile");

    setIsLoading(true);
    username = localStorage.getItem("userInfo");
    const obj = JSON.parse(username);
    setUrl_Mod(url + obj.userFound.email);

    axios
      .get(baseURLGetDoc + "/" + manufile + "/" + obj.userFound.email)
      .then((response) => {
        setJob(response.data);
        setIsLoading(false);
      });

    function pushNoDuplicates(array, newItem) {
      // Check if the item already exists in the array
      const isDuplicate = array.some((item) => {
        return JSON.stringify(item) === JSON.stringify(newItem);
      });

      // If the item is not a duplicate, push it to the array
      if (!isDuplicate) {
        array.push(newItem);
      }
    }

    axios.get(baseURLGetDest).then((response) => {
      
      console.log(response.data.data);

      for (let key in response.data.data) {

        pushNoDuplicates(colourOptions, {
          value: response.data.data[key].destination,
          label: response.data.data[key].schema,
          uuid: response.data.data[key].uuid,
          schema_filename: response.data.data[key].schema_filename,
          color: null,
          isDisabled: false,
        });
      }
    });

  }, []);

  async function verifyDest() {
    console.log("verify");

    username = localStorage.getItem("userInfo");

    const username_from_json = JSON.parse(username);
    //console.log(username_from_json.userFound.email)

    console.log(userChoice);
    if (userChoice == "") {
      //console.log("Error");
      toastError()
      
    } else {
      //console.log("continue with processing");

      toastSuccess();

      // determine length - how many jobs?
      console.log(userChoice[0].schema_filename); // TODO multiple jobs
      localStorage.setItem("schefile", userChoice[0].schema_filename);
      //setTotJobs(colourOptions.length);
      localStorage.setItem("suid", userChoice);
      // for (const { uuid, label, value } of userChoice) {
      //   console.log(uuid);
      //   console.log(label);
      //   console.log(value);
      // }

      console.log(userChoice[0].uuid);
      localStorage.setItem("uuid", userChoice[0].uuid);
      //console.log(typeof userChoice);
      setTotJobs(userChoice.length);

      var tuid = localStorage.getItem("tuid");
      //console.log(tuid);

      let fetchTodo = async () => {
        await axios
          .post(
            baseURLSaveUUID +
              "/" +
              localStorage.getItem("manuuid") +
              "/" +
              username_from_json.userFound.email +
              "/" +
              localStorage.getItem("manufile"),
            {
              dest: userChoice,
            }
          )
          .then((res) => console.log(res.data))
          .then((res) => {
            //console.log(res);
            return res;
          })
          .catch((err) => console.log(err));
      };
      fetchTodo();

      //console.log(url_mod + "&uuid=" + localStorage.getItem("manuuid"));

      setUrl_Mod(url_mod + "&uuid=" + localStorage.getItem("manuuid"));

      //console.log(url_mod)
    }
  }

  function getDest(choice) {
    console.log(choice);
    if (choice.length === 0) {
      setUserChoice("");
    }else {
      setUserChoice(choice);
    }
    
  }

  function saveDoc() {
    console.log("saveDoc");

    // Set loading state to show spinner
    setLoading(true);

    username = localStorage.getItem("userInfo");
    const obj = JSON.parse(username);
    //console.log(obj.userFound.email);
    //setUrl_Mod(url + obj.userFound.email);
    //console.log(url_mod);

    //owner = ''

    //console.log(localStorage.getItem("tuid"));

    axios
      .get(
        baseURLSaveJob +
          "/" +
          localStorage.getItem("tuid") +
          "/" +
          obj.userFound.email
      )
      .then((response) => {
        console.log(response.data);
        toastPublished();
        setModalShow(true);
      })
      .catch((error) => {
        console.error("Error saving document:", error);
        toast.error("Failed to publish document. Please try again.", {
          position: "bottom-right",
          autoClose: 5000,
        });
      })
      .finally(() => {
        // Reset loading state
        setLoading(false);
      });
  }

  function cancelImport() {
    toastCancelImport();
  }

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      editable: false,
      enableCellChangeFlash: true,
    };
  });

  const gridOptions = {
    autoSizeStrategy: {
      type: "fitCellContents",
    },
  };
  const [colDefs, setColDefs] = useState([
    {
      field: "line",
      flex: 1,
    },
    {
      field: "GTIN",
      filter: "agTextColumnFilter",
      editable: true,
    },
    {
      field: "status",
      cellRenderer: statusRenderer,
      width: 20,
    },
    {
      field: "status",
      cellClassRules: {
        "red-cell": (p) => p.value === "failed",
        "green-cell": (p) => p.value === "success",
      },
      filter: "agTextColumnFilter",
    },
    {
      field: "actions",
      headerName: "Actions",
      cellRenderer: ButtonRenderer,
    },
  ]);

  const updateRows = useCallback(
    (gtin, row) => {
      
      const rowNode = gridRef.current.api.getDisplayedRowAtIndex(row);

      //console.log(rowNode)

        if (gtin == "its null") {
          rowNode.setDataValue("status", "failed");
        }
        if (rowNode.data.GTIN == gtin) {
          rowNode.setDataValue("status", "success");
        }

        //console.log(rowNode);
    },
    []
  );

  const onCellValueChanged = (params) => {
    
    //console.log(params);

    axios.get(baseURLGetGS1 + "/" + params.data.GTIN).then((response) => {
      //console.log(response);
      if (response.data === null) {
        //console.log('null');
        updateRows("its null", params.node.id);
      } else {
        //console.log(response.data.gtin);
        updateRows(response.data.gtin, params.node.id);
      }

    });

  };

  const rowSelection = useMemo(() => {
    return {
      mode: "singleRow",
      checkboxes: false,
    };
  }, []);


  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Job Submitted
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>Your job has been submitted, depending on the destination, syndication times will vary.</h4>
          {/* <p>
            Cras mattis consectetur purus sit amet fermentum. Cras justo odio,
            dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta
            ac consectetur ac, vestibulum at eros.
          </p> */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-primary" onClick={handleNavigate}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
//if (!job) return null;
  return (
    <div>
      {isLoading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Bars
            height="80"
            width="80"
            color="#2196f3"
            ariaLabel="bars-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
          &nbsp;&nbsp; Loading data ...
        </div>
      )}
      {!isLoading && job && (
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="sm:flex sm:items-center">
            <div className="sm:flex-auto">
              <br></br>
              <h1 className="text-xl font-semibold text-gray-900">
                Import Product Data
              </h1>
              {/* // TODO fix the language and number of records */}
              <p className="mt-2 text-sm text-gray-700">
                Filename: {localStorage.getItem("manufile")} &nbsp;&nbsp;&nbsp;
                Language: English &nbsp;&nbsp;&nbsp; Number of Records: 8
              </p>
              <br></br>
              <div className="container-fluid vh-100">
                <div className="row h-100">
                  <div className="col ">
                    <br></br>
                    <h3 className="text-lg text-gray-900">
                      Step 1 Pick Destination(s)
                    </h3>
                    <Select
                      isMulti
                      name="colors"
                      options={colourOptions}
                      onChange={(choice) => getDest(choice)}
                      className="basic-multi-select"
                      classNamePrefix="select"
                    />
                    <br></br>
                    <h3 className="text-lg text-gray-900">
                      Step 2: Verify Data
                    </h3>
                    <Button variant="outline-primary" onClick={verifyDest}>
                      VERIFY
                    </Button>
                    &nbsp;&nbsp;&nbsp;
                    <NavLink to="/">
                      <Button variant="outline-danger" onClick={cancelImport}>
                        CANCEL IMPORT
                      </Button>
                    </NavLink>
                  </div>
                  <div className="col-9 d-none d-sm-block">
                    <Tabs
                      defaultActiveKey="validation"
                      id="uncontrolled-tab-example"
                      className="mb-3"
                    >
                      <Tab eventKey="validation" title="Validation">
                        <h3 className="text-lg text-gray-900">
                          Data Validation
                        </h3>
                        <div
                          className="ag-theme-material" // applying the Data Grid theme
                          style={{ height: 800 }}
                        >
                          <AgGridReact
                            ref={gridRef}
                            rowData={job}
                            gridOptions={gridOptions}
                            animateRows={true}
                            columnDefs={colDefs}
                            rowSelection={rowSelection}
                            pagination={true}
                            paginationPageSize={10}
                            paginationPageSizeSelector={[10, 20]}
                            defaultColDef={defaultColDef}
                            frameworkComponents={{
                              ButtonRenderer: ButtonRenderer,
                            }}
                            onCellValueChanged={onCellValueChanged}
                          />
                        </div>
                      </Tab>
                      <Tab eventKey="mapping" title="Mapping">
                        <h3 className="text-lg text-gray-900">Map Data</h3>
                        {
                          //Check if message failed
                          userChoice === "" ? (
                            <div> Please select a destination </div>
                          ) : (
                            <>
                              <MappingComponent name={userChoice} type={'normal'} age={54} />
                              {/* <Iframe
                                url={url_mod}
                                width="900px"
                                height="800px"
                                id="mapper"
                                className=""
                                display="block"
                                position="relative"
                              /> */}
                            </>
                          )
                        }
                      </Tab>
                      <Tab eventKey="publish" title="Publish">
                        <h3 className="text-lg text-gray-900">Publish</h3>
                        {
                          //Check if message failed
                          userChoice === "" ? (
                            <div> Please select a destination </div>
                          ) : (
                            <>
                              <h3 className="text-lg text-gray-900">
                                The following is a visual representation of the
                                publishing process and the destinations.
                              </h3>
                              <br></br>
                              <div>
                                <Form.Check // prettier-ignore
                                  type="gtins"
                                  id="gtins"
                                  label="Exclude invalid GTINs"
                                />
                                <Form.Check // prettier-ignore
                                  type="exclude"
                                  id="exclude"
                                  label="Exclude null products"
                                />
                              </div>

                              <br></br>
                              <Button
                                variant="outline-primary"
                                onClick={saveDoc}
                                disabled={loading}
                                style={{
                                  cursor: loading ? 'wait' : 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '8px'
                                }}
                              >
                                {loading && (
                                  <RotatingLines
                                    strokeColor="#0d6efd"
                                    strokeWidth="3"
                                    animationDuration="0.75"
                                    width="16"
                                    visible={true}
                                  />
                                )}
                                {loading ? "PUBLISHING..." : "PUBLISH"}
                              </Button>

                              <Iframe
                                url="http://localhost:3003"
                                width="900px"
                                height="800px"
                                id=""
                                className=""
                                display="block"
                                position="relative"
                              />
                            </>
                          )
                        }
                      </Tab>
                    </Tabs>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
          <hr></hr>
          <MyVerticallyCenteredModal
            show={modalShow}
            onHide={() => setModalShow(false)}
          />
          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      )}
    </div>
  );
}

export default ImportDocument;
